import Controller from '@ember/controller';
import ComputedProperty from '@ember/object/computed';
import { Task } from 'ember-concurrency';

export default abstract class TransactionalSetupBaseController extends Controller {
  abstract saveTask: Task<void, []>;
  abstract resetTask: Task<void, []>;
  abstract get isDirty(): boolean | ComputedProperty<boolean, boolean>;
}
